import { jsx as I } from "react/jsx-runtime";
import N from "classnames";
import { forwardRef as T, useMemo as b } from "react";
import e from "./index.es602.js";
import { useTheme as E } from "./index.es173.js";
const R = "icon-container-component", j = T(
  ({
    children: a,
    size: o = "medium",
    color: s = "brand",
    shape: n = "square",
    padding: c,
    borderRadius: i = "s",
    testId: u = R,
    disabled: r = !1,
    onClick: t,
    onMouseEnter: f,
    onMouseLeave: l,
    ...d
  }, v) => {
    const m = E().cornerRadius, p = N(e.container, e[o], e[`color-${s}`], {
      [e.circle]: n === "circle",
      [e.disabled]: r,
      [e.clickable]: !!t
    }), y = b(
      () => ({
        padding: c,
        minWidth: typeof o == "number" ? o : void 0,
        minHeight: typeof o == "number" ? o : void 0,
        borderRadius: n === "circle" ? "50%" : m[i]
      }),
      [i, m, c, n, o]
    );
    return /* @__PURE__ */ I(
      "div",
      {
        ref: v,
        className: p,
        style: y,
        "data-testid": u,
        onClick: r ? void 0 : t,
        onMouseEnter: r ? void 0 : f,
        onMouseLeave: r ? void 0 : l,
        tabIndex: t && !r ? 0 : void 0,
        role: t ? "button" : void 0,
        "aria-disabled": r,
        ...d,
        children: a
      }
    );
  }
);
export {
  R as ICON_CONTAINER_DEFAULT_TESTID,
  j as IconContainer
};
//# sourceMappingURL=index.es148.js.map
